<template>
  <div id="password">
    <div class="content bg-black middle login-box">
      <div class="cell">
        <div class="container">
          <div class="row">
            <div class="col-xs-6">
              <div class="text-center inlineb mt50">
                <img src="../assets/images/logo-ww.svg" alt="" />
                <!-- <p class="sub-title white mt50">PARTNER NETWORK</p> -->
              </div>
            </div>
            <div class="col-xs-6">
              <p class="sub-title white text-center">PASSWORD RECOVERY</p>
              <form class="form-horizontal font12 mt15p">
                <div class="form-group">
                  <label for="inputEmail3" class="col-sm-4 control-label white"
                    >Email</label
                  >
                  <div class="col-sm-8">
                    <el-input v-model="email" placeholder="Email"></el-input>
                  </div>
                </div>

                <div class="form-group mt50">
                  <div class="col-xs-8 col-xs-offset-4">
                    <el-button class="button2" @click="reset()"
                      >RESET MY PASSWORD</el-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="nav-footer white font16 text-center">
      <span class="white click inlineb w10" @click="login()"
        ><i class="iconfont3 icon-back"></i> BACK
      </span>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import "../assets/css/login.css";
export default {
  name: "forgetPassword",
  data() {
    return {
      email: "",
    };
  },
  created: function () {
    this.$parent.headerBg();
    this.$parent.footerB();
    // this.$parent.footerCenter();
    let that = this;
    document.onkeypress = function (e) {
      if (that.$router.currentRoute.path != "/password") {
        return;
      }
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.reset();
        return false;
      }
    };
  },
  methods: {
    login() {
      this.$router.push({ path: "/login" });
    },
    reset() {
      if (this.email.trim() == "") {
        this.$message({
          type: "error",
          message: "Reset failed",
        });
        return;
      }
      axios
        .put("/reset", {
          email: this.email,
        })
        .then((res) => {
          if (res.data.modifiedCount == 1) {
            this.$message({
              type: "success",
              message: "Check your email for new password!",
            });
            this.$router.push({ path: "/login" });
          } else {
            this.$message({
              type: "error",
              message: "Reset failed",
            });
          }
        })
        .catch(function (error) {
          // 请求失败处理
          alert(error);
        });
    },
  },
};
</script>

<style>
</style>
